import { AfterContentInit, Directive, EventEmitter, Output, Input } from "@angular/core";

@Directive({
  selector: "[patchDragAutoclose]",
  standalone: false,
})
export class BfxPatchDragAutoclose implements AfterContentInit {
  @Input("patchDragAutoclose")
  public component: any | null = null;

  public ngAfterContentInit(): void {
    if (this.component && !this.component["__bfx_patchDragAutoclose"]) {
      this.component["__bfx_patchDragAutoclose"] = true;

      this.component.bindDocumentClickListener = function bindDocumentClickListener() {
        if (!this.documentClickListener) {
          this.documentClickListener = this.renderer.listen("document", "mousedown", (event) => {
            if (this.overlayVisible) {
              let element: any = event.target;
              let depth = 0;

              while (
                element &&
                element.classList &&
                !element.classList.contains("ui-datepicker") &&
                depth < 20
              ) {
                element = element.parentElement;
                depth++;
              }

              if (element == null || depth >= 20) {
                if (this.overlayVisible) {
                  this.overlayVisible = false;
                  this.onClose.emit(event);
                }

                this.datepickerClick = false;
                this.cd.detectChanges();
              }
            }
          });
        }
      }.bind(this.component);
    }
  }
}
